import { loadStripe, Stripe } from '@stripe/stripe-js';

const STRIPE_PUBLISHABLE_KEY_DEV = 'pk_test_51S2oTbIcRM5MS5PjCbLXdIO7mWr6gqyqrGgjNR65LRlaXjCmTrHCTEBBjDJYcdxYkOmKKwRRqnYf1vhIWzfKaUST00YGRf0qe0';
const STRIPE_PUBLISHABLE_KEY_PROD = 'pk_live_51SvQbf0MhPtIlB8hu6PSTnqaRhRb1D8mamOYsKUqNEAMdUqNlrHTXV9hOIa0AYPW6qbEcvcEY3BXSmPUPnBl3h53000inSD3HX';

// Select key based on REACT_APP_ENV, same switch as services/firebase.ts.
const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_ENV === 'production'
    ? STRIPE_PUBLISHABLE_KEY_PROD
    : STRIPE_PUBLISHABLE_KEY_DEV;

let stripePromise: Promise<Stripe | null> | null = null;

export function getStripe() {
    if (!stripePromise) {
        stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);
    }
    return stripePromise;
}
